angular.module('tgaAdmin').config(['$uibTooltipProvider',
  function ($uibTooltipProvider) {
    $uibTooltipProvider.options({
      appendToBody: true,
    });
  },
]);
